module.exports = __webpack_public_path__ + "7ffb2516d469caff067b078ab90c5eed.wav";